import React, {useRef, useState} from "react";
import {createPortal} from "react-dom";
import {QRCodeCanvas} from "qrcode.react";

export type ReceiveModalProps = {
    address: string;
    onClose: () => void;
}

export const ReceiveModal: React.FC<ReceiveModalProps> = ({address, onClose}) => {
    const [copied, setCopied] = useState(false);
    const overlayRef = useRef<HTMLDivElement>(null);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(address);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Failed to copy address", err);
        }
    };

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === overlayRef.current) {
            onClose();
        }
    };

    return createPortal(
        <div
            ref={overlayRef}
            onClick={handleOverlayClick}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm"
        >
            <div
                className="bg-gradient-to-br from-white via-pink-50 to-purple-50 border border-pink-200 rounded-2xl p-6 shadow-lg w-full max-w-sm relative"
                onClick={() => onClose()}
            >
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-400 hover:text-pink-500 transition text-xl"
                    aria-label="Close modal"
                >
                    &times;
                </button>

                <h2 className="text-xl font-semibold text-gray-800 text-center mb-4">
                    Receive Tokens
                </h2>

                <div className="flex justify-center mb-4">
                    <QRCodeCanvas
                        value={address}
                        size={160}
                        fgColor="#6B21A8"
                        bgColor="transparent"
                        className="rounded-xl shadow-md"
                    />
                </div>

                <div className="text-center text-sm text-gray-600 font-medium mb-1">
                    Your Solana address
                </div>

                <button
                    onClick={handleCopy}
                    className="w-full text-center text-sm font-mono break-all text-purple-600 bg-white border border-pink-200 rounded-lg px-3 py-2 transition hover:bg-pink-50 active:bg-pink-100"
                    title="Click to copy"
                >
                    {address}
                </button>

                {copied && (
                    <div className="mt-3 text-center text-xs text-green-600 font-medium">
                        Copied to clipboard!
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
};